<template>
    <ShareDialog ref="share" :shareConfig="initData">
        <span class="share" style="display: block;" @click="handleShare()"></span>
    </ShareDialog>
</template>

<script>
import ShareDialog from '@/components/shareDialog';

export default {
  props: {
      shareConfig: {
          type: Object
      }
  },
  components: {
    ShareDialog
  },
  data(){
      return {
        shareConfigData: null
      }
  },
  computed: {
	  initData: function () {
	    return this.shareConfig
	  }
  },
  methods: {
      handleShare() {
        // this.$refs.share.visible=!this.$refs.share.visible
        this.$refs.share.show();
      }
  }
}
</script>